import "../CooperationPage/CooperationPage.css";
import Cover from "../../components/Cover/Cover";
import coverImage from "../../assets/images/mainCoverImage.webp";
import coverImageMobile from "../../assets/images/mainCoverImageMobile.webp";

const CooperationPageRu = () => {
  const isMobile = window.innerWidth <= 1199;
  const coverImageToUse = isMobile ? coverImageMobile : coverImage;
  return (
    <div className="page">
      <title>
        Сотрудничество — ООО «Николаевмолпром» | Производитель молочной
        продукции Pastoral
      </title>
      <meta
        name="description"
        content="Приглашаем к сотрудничеству с ООО «Николаевмолпром» — производителем натуральной молочной продукции под ТМ «Pastoral» и «Мумуля». Производство Private label, участие в тендерах, поставки в торговые сети, закупка упаковки и компонентов, новые партнёрства и вакансии."
      />

      <Cover text={"“Pastoral” - Французские традиции"} src={coverImageToUse} />
      <div className="cooperation__page-cooperation">
        <h1 className="cooperation__page-cooperation-title mont-m">
          Приглашение к сотрудничеству:
        </h1>
        <p className="cooperation__page-cooperation-text int-r-21">
          Присоединяйтесь к проектам от ТМ «Pastoral» и ТМ «Мумуля», к созданию
          новых молочных продуктов, открытию новых производственных участков и
          росту продаж. Для Вас у нас подготовлено ультраэксклюзивное à la carte
          возможностей для сотрудничества. Мы участвуем в тендерных поставках,
          изготавливаем продукцию под Private label, поставляем эксклюзивную
          продукцию в торговые сети. Мы разрабатываем новые продукты, поэтому
          заинтересованы в закупке упаковки, компонентов, промышленного
          оборудования и открыты для новых партнерств.
        </p>
        <h2 className="cooperation__page-cooperation-subtitle mont-m">
          Звоните:
        </h2>
        <div className="cooperation__page-cooperation-text int-r-21">
          Главный технолог, Валентина Викторовна <br />{" "}
          <a
            className="cooperation__page-cooperation-link"
            href="tel:+380952881025"
          >
            +38(095)288–10-25
          </a>
        </div>
        <div className="cooperation__page-cooperation-text int-r-21">
          Менеджер по снабжению, Гросу Дмитрий Андреевич <br />{" "}
          <a
            className="cooperation__page-cooperation-link"
            href="tel:+380673159153"
          >
            +38(067)315-91-53
          </a>
        </div>
      </div>
      <div className="cooperation__page-cooperation-wrapper">
        <div className="cooperation__page-team">
          <h1 className="cooperation__page-team-title mont-m">
            Приглашение в команду:
          </h1>
          <p className="cooperation__page-cooperation-text int-r-21">
            Приглашаем Вас стать частью команды «Домановского маслосырзавода»,
            места, где работают с любовью к молоку и уважением к людям.
            Домановский маслосырзавод постоянно развивается, поэтому наша
            команда всегда нуждается в новых сотрудниках, талантливых и
            ответственных. Мы ценим вклад каждого в развитие и успех
            предприятия, ведь рост и достижения — это совместный путь, где важен
            каждый шаг.
          </p>
          <h2 className="cooperation__page-cooperation-subtitle mont-m">
            Звоните:
          </h2>
          <div className="cooperation__page-cooperation-text int-r-21">
            Начальник отдела кадров, Наталья Юрьевна <br />{" "}
            <a
              className="cooperation__page-cooperation-link"
              href="tel:+380982074160"
            >
              +38(098)207-41-60
            </a>
          </div>
          <div className="cooperation__page-cooperation-text int-r-21">
            Начальник производства, Наталья Ивановна <br />{" "}
            <a
              className="cooperation__page-cooperation-link"
              href="tel:+380507004825"
            >
              +38(050)700–48-25
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CooperationPageRu;
